.img {
    mix-blend-mode: color-dodge;
    opacity: 0.35;
}